'use client';

import { ErrorBoundary } from '@sentry/nextjs';
import { memo } from 'react';
import styled from 'styled-components';

import type { SerializedBlock } from '@zoomit/editor';
import { Box, Breakpoints, Col, Flex } from '@zoomit/primitives';
import { ContentParser, isMobile, OverviewProsCons } from '@zoomit/web-kit';
import { cssVar, theme, Typography } from '@zoomit/zoomit-ds';

import { isContentAvailable } from '../../helpers/block';
import { SthWentWrong } from '../error-states/sth-went-wrong';

type Props = {
  cons: string;
  pros: string;
  contentData: SerializedBlock[];
};

const Overview = (props: Props) => {
  const { contentData, pros, cons } = props;

  return (
    <Root justifyContent="space-between">
      <Col md={1.7} size={12}>
        <Title tag="h2" variant="h5">
          جمع بندی
        </Title>
      </Col>
      <Col md={10} size={12}>
        <ErrorBoundary fallback={<SthWentWrong />}>
          <Flex
            spacing={{ px: isMobile ? 'x4' : 'x0' }}
            flexDirection={'column'}
            alignItems={'center'}
            justifyContent={'center'}
          >
            {isContentAvailable(contentData) && <ContentParser contentData={contentData} />}
            {(pros || cons) && (
              <Box
                style={{ width: '100%', maxWidth: 760 }}
                spacing={{ pt: isContentAvailable(contentData) ? 'x6' : 'x0' }}
              >
                <OverviewProsCons pros={pros} cons={cons} />
              </Box>
            )}
          </Flex>
        </ErrorBoundary>
      </Col>
    </Root>
  );
};
export default memo(Overview);

const Root = styled(Flex)`
  flex-direction: column;
  gap: 2.6rem;

  @media (min-width: ${Breakpoints.lg}) {
    flex-direction: row;
    gap: 0;
  }
`;

const Title = styled(Typography)`
  position: relative;
  padding-right: 1.6rem;

  &::after {
    content: '';
    position: absolute;
    top: 0.8rem;
    right: 0;
    transform: translateY(-50%);
    width: 0.4rem;
    height: 2.4rem;
    background-color: ${cssVar(theme.primary1)};
  }
`;
